import { defineMessages } from 'react-intl-next';

export default defineMessages({
	goodResponseLabel: {
		id: 'chatHistory.storeAssistant.goodResponseLabel',
		defaultMessage: 'Good response',
		description: 'Label for the good response button',
	},
	badResponseLabel: {
		id: 'chatHistory.storeAssistant.badResponseLabel',
		defaultMessage: 'Bad response',
		description: 'Label for the bad response button',
	},
});
